import React from "react";
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';

class LivecamMetadata extends React.Component {
  render() {
    const { title, description, thumb, latLong, isPrimary, tags} = this.props;
    const currentUrl = window.location.href;
    let meta = [
      {name:'keywords', content:tags},
      {name:'description', content:description},
      /* Schema.org markup for Google+ */
      {itemprop:'name', content:title},
      {itemprop:'description', content:description},
      {itemprop:'image', content:thumb},
      /* Twitter Card data */
      {name:'twitter:card', content:'summary_large_image'},
      {name:'twitter:site', content:'@publisher_handle'},
      {name:'twitter:title', content:title},
      {name:'twitter:description', content:description},
      {name:'twitter:creator', content:'@exploreorg'},
      /* Twitter summary card with large image must be at least 280x150px */
      {name:'twitter:image:src', content:thumb},
      /* Open Graph data */
      {property:'og:title', content:title},
      {property:'og:type', content:'article'},
      {property:'og:url', content:currentUrl},
      {property:'og:image', content:thumb},
      {property:'og:description', content:description},
      {property:'og:site_name', content:'Explore.org'},
      /*{property:'article:published_time', content:'2013-09-17T05:59:00+01:00'},
      {property:'article:modified_time', content:'2013-09-16T19:08:47+01:00'},*/
      {property:'article:section', content:'Article Section'}, /* should we use article or video? */
      {property:'article:tag', content:'Article Tag'}, /* should we use article or video? */
      {property:'fb:admins', content:'Facebook numberic ID'},
    ];

    let link = [];

    if(latLong) {
      meta.push(
        {property:'place:location:latitude',  content:latLong[0]},
        {property:'place:location:longitude', content:latLong[1]}
      )
    }

    if(!isPrimary) {
      meta.push(
        {name:'robots', content:'noindex'}
      );
      link.push({ rel:"canonical", href:"http://explore/org/"});
    }
    if(title) document.title = title;
    return (
      <div>
        <Helmet
          title={title}
          meta={meta}
          link={link}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    title: state.currentItem.data.meta_title,
    description: state.currentItem.data.description,
    thumb: state.currentItem.data.thumb,
    latLong: state.currentItem.data.latLong,
    isPrimary: state.currentItem.data.primary_feed,
    tags: state.currentItem.data.tags,
  };
};

export default connect(mapStateToProps)(LivecamMetadata);
